import * as React from 'react';
import { SVGProps, Ref, forwardRef } from 'react';
const SvgCheckCircle = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="m5.6 8 1.6 1.6 3.2-3.2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx={8} cy={8} r={7.5} stroke="currentColor" />
  </svg>
);
const ForwardRef = forwardRef(SvgCheckCircle);
export default ForwardRef;
